import { render, staticRenderFns } from "./dataPackage.vue?vue&type=template&id=e1d3075a&scoped=true"
import script from "./dataPackage.vue?vue&type=script&lang=js"
export * from "./dataPackage.vue?vue&type=script&lang=js"
import style0 from "./dataPackage.vue?vue&type=style&index=0&id=e1d3075a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d3075a",
  null
  
)

export default component.exports